/* eslint-disable react/function-component-definition */
import React, { useImperativeHandle, useState, useEffect } from 'react';
import Image from '$/components/NextImage';
import { mtstatTrack } from '$/utils/mtstat';
import { useOfficialStore } from '$/store/useOfficialStore';
import IconFont from '$/components/IconFont';
import RoboneoModal from '$/components/Modal';
import { checkMeiyeAmount } from '$/api/server';
import { useLanguageStore } from '$/store/languageStore';
import Button from '$/components/base/Button';
import { openSingleProductModal } from '$/store/useVipModalStore';
import CalcTabs from './CalcTabs';
import { VIP_MODAL_CHILD_Z_INDEX } from '../constants';
import styles from './index.module.scss';
import remainIcon from '../SingleCategoryItem/order-1.png';

interface VipModalProps {
  // userInfo: { uid: string; screenName: string; avatar: string; } | undefined;
}
export interface MyCalcDetaiRef {
  openMyCalcDetail: () => void;
}

/**
 * 展示当前账号算力萝卜余额和获取 / 消耗明细，并保持其层级高于订阅主弹窗。
 */
const MyCalcDetailModal: React.ForwardRefRenderFunction<MyCalcDetaiRef, VipModalProps> = (props, ref) => {
  const [open, setOpen] = useState(false);
  const radishAmount = useOfficialStore((state) => state.radishAmount);
  const languageStore = useLanguageStore((state) => state.languageStore);

  /**
   * 从明细弹窗切换到单购弹窗，避免两个购买相关弹层叠加遮挡。
   */
  const handleOpenSingleProductModal = () => {
    setOpen(false);
    openSingleProductModal('topright_page');
  };

  useImperativeHandle(ref, () => ({
    openMyCalcDetail: () => {
      setOpen(true);
    },
  }));
  useEffect(() => {
    if (open) {
      checkMeiyeAmount();
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      mtstatTrack('payment_detail_show', {
      });
    }
  }, [open]);

  return (
    <RoboneoModal
      destroyOnClose
      zIndex={VIP_MODAL_CHILD_Z_INDEX}
      wrapClassName={styles['my-calc-modal-wrapper']}
      bodyClassName={styles.calcModalbody}
      open={open}
      onCancel={() => { setOpen(false); }}
      closable
    >
      <div className={styles.title}>{languageStore.smartcatTranslationText((v) => v.my_cyber_carrots)}</div>
      <div className={styles['myCalc-container']}>

        <div className={styles['myCalc-content']}>
          <div className={styles.header}>
            <div className={styles['radish-count']}>
              <Image alt="" src={remainIcon} width={44} height={44} />
              <IconFont name="crossBlack" fontSize={20} color="var(--content-tertiary)" />
              <div className={styles.price}>{radishAmount}</div>
            </div>
            <Button
              type="primary"
              size="small"
              className={styles['single-product-button']}
              buttonStyle={{ height: 36 }}
              onClick={handleOpenSingleProductModal}
            >
              {languageStore.smartcatTranslationText((v) => v.single_purchase_of_radish)}
            </Button>
          </div>
          {/* <div className={styles['remain-detail']}>
            <div className={styles['remain-detail-item']}>
              <div className={styles['remain-detail-item-label']}>充值萝卜：</div>
              <div className={styles['remain-detail-item-value']}> 3333</div>
            </div>
            <div className={styles['remain-detail-item']}>
              <div className={styles['remain-detail-item-label']}>充值萝卜：</div>
              <div className={styles['remain-detail-item-value']}> 3333</div>
            </div>
          </div> */}
          <CalcTabs
            items={[{ label: languageStore.smartcatTranslationText((v) => v.get), key: 'get' }, { label: languageStore.smartcatTranslationText((v) => v.spent), key: 'custom' }]}
          />
        </div>
      </div>
    </RoboneoModal>
  );
};
export default React.forwardRef(MyCalcDetailModal);
